import React from "react";
import { ConfigProvider, theme } from "antd";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import AppRouter from "./router/AppRouter";

const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: "#2e7d6e",
          colorBgBase: "#f6f8f4",
          borderRadius: 18,
          colorTextBase: "#182230",
        },
      }}
    >
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" />
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default App;
